import React from "react";

/**
 * Reusable status pill.
 *   <StatusTag type="green" text="Open" />
 *   <StatusTag type="amber" text="Pending" size="sm" />
 *   <StatusTag type="red" text="Failed" icon="✗" />
 *
 * Built-in palettes match the rest of the admin UI. Pass an explicit
 * `bg` + `color` to override.
 */
const PALETTE = {
  green:   { bg: "#ECFDF5", color: "#047857", border: "#A7F3D0" },
  lime:    { bg: "#F0FDF4", color: "#16A34A", border: "#BBF7D0" },
  amber:   { bg: "#FEF3C7", color: "#92400E", border: "#FDE68A" },
  orange:  { bg: "#FFF7ED", color: "#C2410C", border: "#FED7AA" },
  red:     { bg: "#FEF2F2", color: "#991B1B", border: "#FCA5A5" },
  blue:    { bg: "#EFF6FF", color: "#1D4ED8", border: "#BFDBFE" },
  indigo:  { bg: "#EEF2FF", color: "#4338CA", border: "#C7D2FE" },
  violet:  { bg: "#F5F3FF", color: "#6D28D9", border: "#DDD6FE" },
  rose:    { bg: "#FFF1F2", color: "#BE123C", border: "#FECDD3" },
  slate:   { bg: "#F1F5F9", color: "#475569", border: "#E2E8F0" },
  // semantic aliases
  success: null, warning: null, danger: null, info: null, neutral: null,
};
PALETTE.success = PALETTE.green;
PALETTE.warning = PALETTE.amber;
PALETTE.danger  = PALETTE.red;
PALETTE.info    = PALETTE.blue;
PALETTE.neutral = PALETTE.slate;

const SIZES = {
  xs: { padding: "1px 6px", fontSize: 9 },
  sm: { padding: "2px 8px", fontSize: 10 },
  md: { padding: "3px 10px", fontSize: 11 },
  lg: { padding: "4px 12px", fontSize: 12 },
};

const StatusTag = ({
  type = "slate",
  text,
  children,
  icon,
  size = "sm",
  bordered = false,
  bg,
  color,
  className,
  style,
  title,
  onClick,
}) => {
  const palette = PALETTE[type] || PALETTE.slate;
  const sz = SIZES[size] || SIZES.sm;
  const finalBg = bg || palette.bg;
  const finalColor = color || palette.color;
  const finalBorder = bordered ? `1px solid ${palette.border}` : "none";

  return (
    <span
      className={className}
      title={title}
      onClick={onClick}
      style={{
        display: "inline-flex", alignItems: "center", gap: 4,
        padding: sz.padding, fontSize: sz.fontSize, fontWeight: 600,
        borderRadius: 999, background: finalBg, color: finalColor,
        border: finalBorder, lineHeight: 1.2, whiteSpace: "nowrap",
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
    >
      {icon && <span style={{ fontSize: sz.fontSize, lineHeight: 1 }}>{icon}</span>}
      {text ?? children}
    </span>
  );
};

export default StatusTag;
